<template>
    <vue-scroll>
        <single ref="single" />
    </vue-scroll>
</template>

<script>
import Single from "./Single";
import unsaved_changes_mixin from "../../../mixins/unsaved-changes";

export default {
    mixins: [unsaved_changes_mixin],
    components: {
        Single,
    },
    data() {
        return {};
    },
    computed: {
        hasChanges() {
            return _.get(this.$refs, "single.hasChanges");
        },
    },
    methods: {},
};
</script>

<style scoped></style>
